import angular from 'angular';

angular.module('cloudX').directive('cxLoadingSm', [
  '$compile',
  function($compile) {
    var loadingSpinner =
      '<div class="sk-circle">' +
      ' <div class="sk-circle1 sk-child" ></div>' +
      ' <div class="sk-circle2 sk-child"></div>' +
      ' <div class="sk-circle3 sk-child"></div>' +
      ' <div class="sk-circle4 sk-child"></div>' +
      ' <div class="sk-circle5 sk-child"></div>' +
      ' <div class="sk-circle6 sk-child"></div>' +
      ' <div class="sk-circle7 sk-child"></div>' +
      ' <div class="sk-circle8 sk-child"></div>' +
      ' <div class="sk-circle9 sk-child"></div>' +
      ' <div class="sk-circle10 sk-child"></div>' +
      ' <div class="sk-circle11 sk-child"></div>' +
      ' <div class="sk-circle12 sk-child"></div>' +
      ' </div>';

    return {
      restrict: 'A',
      terminal: true,

      link: function(scope, element, attrs) {
        var originalContent = element.html();
        element.html(loadingSpinner);

        scope.$watch(attrs.cxLoadingSm, function(val) {
          if (val === false || (val && val !== true)) {
            element.html(originalContent);
            $compile(element.contents())(scope);
          } else {
            element.html(loadingSpinner);
          }
        });
      },
    };
  },
]);
